import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JobPage from './pages/job/Page';
import TransactionPage from './pages/transaction/Page';
import ShareHousePage from './pages/sharehouse/Page';
// import LoginForm from './pages/LoginForm';
import MyPage from './pages/user/MyPage';
import ChatPage from './pages/chat/ChatPage';
// import CreatUser from './pages/CreatUser';
import JobDetailPage from './pages/job/DetailPage';
import TransactionDetailPage from './pages/transaction/DetailPage';
import JobPostForm from './pages/job/PostPage';
import ShareHousePostForm from './pages/sharehouse/PostPage';
import Map from './pages/sharehouse/Map';
import ShareHouseDetailPage from'./pages/sharehouse/DetailPage';
import TransactionPostForm from './pages/transaction/PostPage';
import FrontPage from './pages/FrontPage';
import useFetchData from './hooks/useFetchData';
import ChatListPage from './pages/chat/ChatList';
import TermOfUsePage from './pages/TermsOfUse';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import PaymentForm from './components/shared/payment';
import PostCompletePage from './components/shared/PostComplete';
import PostComplateError from './components/shared/PostComplate-error';
import PaymentSuccees from './components/shared/Succees';
import PaymentChancel from './components/shared/Chancel';

function FetchDataPage() {
  const { data, loading, error } = useFetchData('/get-token');
  return <div>データ: {JSON.stringify(data)}</div>;
}

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<FrontPage />} />
          <Route path="/job" element={<JobPage />} />
          <Route path="/transaction" element={<TransactionPage />} />
          <Route path="/sharehouse" element={<ShareHousePage />} />
          <Route path="/sharehouse/map" element={<Map />} />
          <Route path="/job/:postId" element={<JobDetailPage />} />
          <Route path="/sharehouse/:postId" element={<ShareHouseDetailPage />} />
          <Route path="/transaction/:postId" element={<TransactionDetailPage />} />
          {/* <Route path="/login" element={<LoginForm />} /> */}
          <Route path="/mypage" element={<MyPage />} />
          {/* <Route path="/creat_user" element={<CreatUser />} /> */}
          <Route path="/get-token" element={<FetchDataPage />} />
          <Route path="/sharehouse_post" element={<ShareHousePostForm />} />
          <Route path="/job_post" element={<JobPostForm />} />
          <Route path="/transaction_post" element={<TransactionPostForm />} />
          <Route path="/chat/:chatRoomId/:minUserId/:maxUserId/" element={<ChatPage />} /> 
          <Route path="/chat_list" element={<ChatListPage />}/>
          <Route path="/terms-of-service" element={<TermOfUsePage />}/>
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />}/>
          <Route path="/payment" element={<PaymentForm />}/>
          <Route path="/post_complete" element={<PostCompletePage />}/>
          <Route path="/post_complete_error" element={<PostComplateError />}/>
          <Route path="/success" element={<PaymentSuccees />}/>
          <Route path="/chancel" element={<PaymentChancel />}/>
        </Routes>
    </Router>
  );
}

export default App;